import { List, Typography } from "antd"
import { FileInputForm } from "./fileInput"
import { Visibility } from "../../../../shared"
import { toFileList } from "../../../../../helpers"
import { withForm } from "../../../../../helpers/withForm/index.js"
import PropTypes from "prop-types"

/**
 * Note: This component depends on the global styles defined in the LegalDocumentsForm.styles.sass file
 */
LegalDocumentsForm.propTypes = {
  data: PropTypes.object,
  isGovernment: PropTypes.func,
  addDocument: PropTypes.func,
  removeDocument: PropTypes.func,
  disabled: PropTypes.bool
}

function LegalDocumentsForm({
  data,
  isGovernment,
  addDocument,
  removeDocument,
  disabled
}) {
  const letterOfIntentActor = isGovernment ?
    "titular de la dependencia" :
    "representante legal"

  const onDoneFile = (files, type) => {
    addDocument(files[0], type)
  }

  const onRemoveFile = type => {
    removeDocument(type)
  }

  const getFile = type => {
    const doc = data?.documents?.find(doc => doc.type === type)
    return doc ? toFileList([{ ...doc }]) : []
  }

  return (
    <div className="LegalDocumentsForm fico implementer legal-documents">
      <Typography.Text>
        Para continuar, por favor adjuntar los documentos que se
        solicitan a continuación y al finalizar da click en
        &quot;Guardar&quot;
      </Typography.Text>
      <List bordered>
        <FileInputForm
          label={isGovernment ? "Carta intención" : "Acta donde conste el Consejo Directivo Actual"}
          helpText={isGovernment ? `Con ficha técnica firmada por
            el ${letterOfIntentActor}` : "Debes de presentar el acta de asamblea protocolizada donde conste el Consejo Directivo con una antigüedad no mayor a 1 año."}
          fileList={getFile("INTENTION_LETTER")}
          onRemoveFile={() => onRemoveFile("INTENTION_LETTER")}
          onChange={files => onDoneFile(files, "INTENTION_LETTER")}
          accept={"application/pdf"}
          disabled={disabled} />
        <FileInputForm
          label="Identificación oficial del representante legal"
          fileList={getFile("REP_ID")}
          onRemoveFile={() => onRemoveFile("REP_ID")}
          onChange={files => onDoneFile(files, "REP_ID")}
          accept={"application/pdf"}
          disabled={disabled} />
        <FileInputForm
          label="Copia de comprobante de domicilio fiscal"
          helpText="Que coincida con el RFC no mayor a tres meses"
          fileList={getFile("FISCAL_ADDRESS_DOC")}
          onRemoveFile={() => onRemoveFile("FISCAL_ADDRESS_DOC")}
          onChange={files => onDoneFile(files, "FISCAL_ADDRESS_DOC")}
          accept={"application/pdf"}
          disabled={disabled} />
        <FileInputForm
          label="Constancia de situación fiscal"
          fileList={getFile("FISCAL_ID")}
          helpText="Expedida con una vigencia no mayor a 3 meses`"
          onRemoveFile={() => onRemoveFile("FISCAL_ID")}
          onChange={files => onDoneFile(files, "FISCAL_ID")}
          accept={"application/pdf"}
          disabled={disabled} />
        <FileInputForm
          label="Copia de convenio con aliados"
          helpText="Solo en caso de ser más actores financiadores del proyecto"
          fileList={getFile("ALLIES_AGREEMENT")}
          onRemoveFile={() => onRemoveFile("ALLIES_AGREEMENT")}
          onChange={files => onDoneFile(files, "ALLIES_AGREEMENT")}
          accept={"application/pdf"}
          disabled={disabled} />
        <Visibility visible={isGovernment}>
          <FileInputForm
            label="Decreto de creación"
            fileList={getFile("CREATION_ACT")}
            onRemoveFile={() => onRemoveFile("CREATION_ACT")}
            onChange={files => onDoneFile(files, "CREATION_ACT")}
            accept={"application/pdf"}
            disabled={disabled} />
          <FileInputForm
            label="Ley o reglamento que otorga facultades
                  al representante legal"
            fileList={getFile("REP_RULES")}
            onRemoveFile={() => onRemoveFile("REP_RULES")}
            onChange={files => onDoneFile(files, "REP_RULES")}
            accept={"application/pdf"}
            disabled={disabled} />
          <FileInputForm
            label="Nombramiento de quien funge como representante legal
                  o titular"
            fileList={getFile("REP_NAMING")}
            onRemoveFile={() => onRemoveFile("REP_NAMING")}
            onChange={files => onDoneFile(files, "REP_NAMING")}
            accept={"application/pdf"}
            disabled={disabled} />
        </Visibility>
        <Visibility visible={!isGovernment}>
          <FileInputForm
            label="Curriculum de la implementadora"
            fileList={getFile("IMPLEMENTER_RESUME")}
            onRemoveFile={() => onRemoveFile("IMPLEMENTER_RESUME")}
            onChange={files => onDoneFile(files, "IMPLEMENTER_RESUME")}
            accept={"application/pdf"}
            disabled={disabled} />
          <FileInputForm
            label="Acta constitutiva"
            helpText="Protocolizada ante Notario Público
                  de la o las OSC que intervienen en el proyecto"
            fileList={getFile("CONSTITUTIVE")}
            onRemoveFile={() => onRemoveFile("CONSTITUTIVE")}
            onChange={files => onDoneFile(files, "CONSTITUTIVE")}
            accept={"application/pdf"}
            disabled={disabled} />
          <FileInputForm
            label="Poder notariado del representante legal"
            helpText="Registrado ante el Registro Público"
            fileList={getFile("NOTARY")}
            onRemoveFile={() => onRemoveFile("NOTARY")}
            onChange={files => onDoneFile(files, "NOTARY")}
            accept={"application/pdf"}
            disabled={disabled} />
          <FileInputForm
            label="Oficio de donataria autorizada por la SAT"
            fileList={getFile("SAT_DONATARY")}
            onRemoveFile={() => onRemoveFile("SAT_DONATARY")}
            onChange={files => onDoneFile(files, "SAT_DONATARY")}
            accept={"application/pdf"}
            disabled={disabled} />
          <FileInputForm
            label="Opinión de cumplimiento de obligaciones fiscales
                  emitida por la SAT"
            fileList={getFile("SAT_OBLIGATIONS")}
            helpText="Expedida con una vigencia no mayor a 1 mes"
            onRemoveFile={() => onRemoveFile("SAT_OBLIGATIONS")}
            onChange={files => onDoneFile(files, "SAT_OBLIGATIONS")}
            accept={"application/pdf"}
            disabled={disabled} />
          <FileInputForm
            label="Copia del último informe de actividades"
            helpText="El informe debe ser de elaboración propia"
            fileList={getFile("ACTIVITIES_DOC")}
            onRemoveFile={() => onRemoveFile("ACTIVITIES_DOC")}
            onChange={files => onDoneFile(files, "ACTIVITIES_DOC")}
            accept={"application/pdf"}
            disabled={disabled} />
        </Visibility>
      </List>
    </div>
  )
}

export default withForm(LegalDocumentsForm)
